import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useTokenRouting = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [, p, contractId, accountId, selectedTokenId, authContract] =
    location.pathname.split("/");

  const buildPath = (
    _contractId,
    _accountId,
    _selectedTokenId,
    _authContract
  ) => {
    let path = `/${p}`;

    const showAuthContract = !!_authContract;
    const showTokenId = showAuthContract || !!_selectedTokenId;
    const showAccountId = showTokenId || !!_accountId;
    const showContractId = showAccountId || !!_contractId;

    if (showContractId) {
      path += `/${_contractId || ""}`;
    }
    if (showAccountId) {
      path += `/${_accountId || ""}`;
    }
    if (showTokenId) {
      path += `/${_selectedTokenId || ""}`;
    }
    if (showAuthContract) {
      path += `/${_authContract || ""}`;
    }

    return path;
  };

  const setContractId = (_contractId) => {
    navigate(buildPath(_contractId, accountId, selectedTokenId, authContract), {
      replace: true,
    });
  };

  const setAccountId = (_accountId) => {
    navigate(buildPath(contractId, _accountId, selectedTokenId, authContract), {
      replace: true,
    });
  };

  const setSelectedTokenId = (_selectedTokenId) => {
    navigate(buildPath(contractId, accountId, _selectedTokenId, authContract), {
      replace: true,
    });
  };

  const setAuthContract = (_authContract) => {
    navigate(buildPath(contractId, accountId, selectedTokenId, _authContract), {
        replace: true,
      });
  }

  return {
    contractId,
    accountId,
    selectedTokenId,
    authContract,
    setContractId,
    setAccountId,
    setSelectedTokenId,
    setAuthContract
  };
};

export default useTokenRouting;
